import styled from 'styled-components';

export const TabBarContainer = styled.div`
  display: block;
  height: 100%;
  padding: 10px 30px;
  text-align: center;
`;

export const TabBarItem = styled.div`
  display: inline-block;
  height: 100%;
  width: calc((100% - 150px) / ${(props) => props.num});
  max-width: 200px;
  min-width: 150px;
  border: solid 1px var(--logo-gray);  
  text-align: center;
  padding: 15px;
  :hover {
    background-color: var(--logo-orange);
    border: solid 1px var(--logo-orange);
    color: white;
    font-weight: bold;
    cursor: pointer;
  }, 
  ${(props) => props.selected} {
    background-color: var(--logo-orange);
    border: solid 1px var(--logo-orange);
    color: white;
    font-weight: bold;
  }
`;
